<template>
  <div class="grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Grid'
}
</script>

<style lang="less" scoped>
@import '../styles/index.less';

.grid {
  // border: 2px solid green;
  position: relative;
  overflow: hidden;
  background-color: #f7f7f7;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
</style>
